import { uniq } from 'lodash';
import { isConfigurableReceiptField } from './receiptFields.ts';

/**
 * Converte la stringa CSV dei campi visibili in un array di identificatori,
 * rimuovendo spazi, duplicati e identificatori non gestiti dall'enum
 * `ReceiptField` (compresi i valori vuoti).
 */
export function parseReceiptVisibleFields(rawVisibleFields: string) {
  return uniq(
    rawVisibleFields
      .split(',')
      .map(field => field.trim())
      .filter(isConfigurableReceiptField),
  );
}

/**
 * Campi della ricevuta configurati via `RECEIPT_VISIBLE_FIELDS`, calcolati una
 * sola volta al load del modulo: il valore è sostituito da DefinePlugin a
 * build-time. Contiene solo identificatori gestiti dall'enum `ReceiptField`.
 */
export const receiptVisibleFields = parseReceiptVisibleFields(
  process.env.RECEIPT_VISIBLE_FIELDS ?? '',
);
